module.exports = __webpack_public_path__ + "static/img/service-2.d8e665ef.jpg";